import { compose, equals } from 'ramda';

import { userLocale } from 'app/features/user/selectors';
import { DEFAULT_LOCALE } from 'app/features/localization/constants';

const isDoNotSellVisible = compose(equals(DEFAULT_LOCALE), userLocale);
const isAdChoicesVisible = compose(equals(DEFAULT_LOCALE), userLocale);

export { isDoNotSellVisible, isAdChoicesVisible };
